import React from "react";
import styles from "./styles/suggestions.module.scss";
import SuggestionBlock from "@/components/pages/text-to-music/components/suggestion-block";
import { useTextToMusicContext } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";

const Suggestions = () => {
  const suggestions = [
    {
      key: 1,
      text: "A traditional Japanese taiko drum ensemble, exuding power and precision.",
    },
    {
      key: 2,
      text: "Compose an energetic electronic track with a high BPM, inspired by early 2000s techno, featuring vibrant synth melodies",
    },
    {
      key: 3,
      text: "Create a tranquil acoustic guitar piece with gentle strumming and a relaxed, calming tempo, evoking the feel of a peaceful evening",
    },
    {
      key: 4,
      text: "Craft a smooth jazz composition centered around saxophone and piano, capturing the ambiance of a cozy late-night jazz lounge",
    },
  ];

  const { handleTextChange } = useTextToMusicContext();

  return (
    <div className={styles.wrapper}>
      <p className={styles.header}>Suggestions</p>
      <div className={styles.suggestions_wrapper}>
        {suggestions.map((suggestion) => (
          <SuggestionBlock
            key={suggestion.key}
            text={suggestion.text}
            onClick={handleTextChange}
          />
        ))}
      </div>
    </div>
  );
};

export default Suggestions;
